import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';
import { AssetBucketingDTO } from './useAssetBucketQuery';

const toggleClassificationType = (data: AssetBucketingDTO) => {
  return authFetch('/Adviser/AssetBucketing/ToggleClassificationType', {
    method: 'POST',
    ...httpBodyOptions(data, true),
  });
};

export const useToggleClassificationTypeMutation = () => {
  return useMutation(toggleClassificationType);
};
